import React from 'react';
import { StorageOptions, Storage } from './styles';

interface MemorySelectorProps {
  availableSizes: string[];
  selectedStorageSize: string;
  selectSize(...args: unknown[]): unknown;
}

const MemorySelector = ({
  availableSizes,
  selectedStorageSize,
  selectSize,
}: MemorySelectorProps) => (
  <StorageOptions className="memorySelector">
    {availableSizes
        && availableSizes.map((storageCapacity) => (
          <Storage
            key={storageCapacity}
            onClick={() => selectSize(storageCapacity)}
            selectedStorageSize={selectedStorageSize}
            size={storageCapacity}
          >
            {storageCapacity}
          </Storage>
        ))}
  </StorageOptions>
);

export default MemorySelector;
